// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Cards__Wrapper_tzym0 grid","Title":"Cards__Title_gLdXF","Card":"Cards__Card_3Gm0-","Text":"Cards__Text_gcba2","Link":"Cards__Link_3Zko1"};